import { Box, Dropdown, HStack, Spacer, VStack } from '@sgme/ui';
import { FormattedMessage } from 'react-intl';

import { useAppDispatch } from '@/store/hooks.ts';
import { removeTile } from '@/store/tiles/slice.ts';

export function UnauthorizedTile({ tileId }: { tileId: string }) {
  const dispatch = useAppDispatch();

  return (
    <VStack className="bg-lvl1 py-2" fullWidth fullHeight>
      <HStack className="mb-2" flex="min">
        <Spacer />
        <Dropdown color={'flat-primary' as 'primary'} direction="auto" size="md" data-e2e="tile-menu">
          <Dropdown.Toggle className="btn-icon" data-e2e="menu-button">
            <i className="icon">more_vert</i>
          </Dropdown.Toggle>
          <Dropdown.Menu>
            <Dropdown.Item onClick={() => dispatch(removeTile(tileId))} data-e2e="close-tile-menu">
              <FormattedMessage id="tile.unauthorized.close" />
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      </HStack>
      <VStack className="bg-lvl1 ps-2 pe-2" fullWidth flex="expand">
        <Box flex="min">
          <h3>
            <span className="icon">lock</span>
            <FormattedMessage id="tile.unauthorized.title" />
          </h3>
        </Box>
        <Box className="mt-2" flex="expand">
          <FormattedMessage id="tile.unauthorized.description" />
        </Box>
      </VStack>
    </VStack>
  );
}
